import { getConfig } from '../getConfig'

const pinsResourcesBaseUrl = `${process.env.REACT_APP_RESOURCES_BASE_URL}/assets/pins`
const pinBagPlusIcon = `${pinsResourcesBaseUrl}/pin_bag_plus_sign.svg`
const pinPlusIcon = `${pinsResourcesBaseUrl}/pin_plus_sign.svg`

const { isBoticario } = getConfig()

export function getPinIcon() {
  return isBoticario ? pinPlusIcon : pinBagPlusIcon
}
